import React from 'react';
import { Check, HandshakeIcon } from 'lucide-react';
import { EditableImage } from '../components/EditableImage';
import { EditableContent } from '../components/EditableContent';

const Partners = () => {
  const sponsorshipBenefits = [
    'Visibilité accrue',
    'Renforcement de votre image',
    'La plus grande associations de Suisse dans le domaine des assurances'
  ];

  const currentPartners = [
    {
      name: 'Baloise',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Baloise_logo.svg/2560px-Baloise_logo.svg.png',
      alt: 'Logo Baloise'
    },
    {
      name: 'La Mobilière',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Die_Mobiliar_Logo_2022.svg/2560px-Die_Mobiliar_Logo_2022.svg.png',
      alt: 'Logo La Mobilière'
    }
  ];

  const sponsors = [
    {
      name: 'Le Paradise',
      logo: 'https://i.imgur.com/YourParadiseLogo.png',
      alt: 'Logo Le Paradise'
    },
    {
      name: 'Tenuta',
      logo: 'https://i.imgur.com/YourTenutaLogo.png',
      alt: 'Logo Tenuta'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-serif font-bold text-dark mb-12">
        <EditableContent
          section="partners"
          contentKey="main-title"
          defaultValue="Devenez notre partenaire/sponsor"
        />
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-24">
        <div className="text-center">
          <div className="inline-block p-8 bg-cream/30 rounded-full mb-6">
            <HandshakeIcon className="h-24 w-24 text-dark" />
          </div>
          <h2 className="text-2xl font-bold text-dark mb-4">
            <EditableContent
              section="partners"
              contentKey="support-title"
              defaultValue="SOUTENEZ-NOUS"
            />
          </h2>
        </div>

        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="bg-dark text-beige p-6 text-center">
            <div className="flex justify-center mb-2">
              <span className="text-2xl">★</span>
            </div>
            <h3 className="text-xl font-bold">
              <EditableContent
                section="partners"
                contentKey="platinum-title"
                defaultValue="FORMULE PLATINIUM"
              />
            </h3>
          </div>
          
          <div className="p-8">
            <ul className="space-y-6">
              {sponsorshipBenefits.map((benefit, index) => (
                <li key={index} className="flex items-start gap-4">
                  <Check className="h-5 w-5 text-green-500 flex-shrink-0 mt-1" />
                  <div className="flex-1 text-dark/80">
                    <EditableContent
                      section="partners"
                      contentKey={`benefit-${index}`}
                      defaultValue={benefit}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Current Partners Section */}
      <section className="mb-24">
        <h2 className="text-3xl font-serif font-bold text-dark mb-12">
          <EditableContent
            section="partners"
            contentKey="partners-title"
            defaultValue="Nos partenaires"
          />
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {currentPartners.map((partner, index) => (
            <div 
              key={partner.name}
              className="bg-white rounded-lg shadow-lg p-12 flex items-center justify-center hover:transform hover:scale-105 transition-all duration-300 min-h-[200px]"
            >
              <EditableImage
                section="partners"
                imageKey={`partner-${index}`}
                defaultSrc={partner.logo}
                alt={partner.alt}
                className="max-h-48 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </section>

      {/* Sponsors Section */}
      <section>
        <h2 className="text-3xl font-serif font-bold text-dark mb-12">
          <EditableContent
            section="partners"
            contentKey="sponsors-title"
            defaultValue="Nos sponsors"
          />
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {sponsors.map((sponsor, index) => (
            <div 
              key={sponsor.name}
              className="bg-white rounded-lg shadow-lg p-12 flex items-center justify-center hover:transform hover:scale-105 transition-all duration-300 min-h-[200px]"
            >
              <EditableImage
                section="sponsors"
                imageKey={`sponsor-${index}`}
                defaultSrc={sponsor.logo}
                alt={sponsor.alt}
                className="max-h-48 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Partners;